import { RigidBody } from "@react-three/rapier"
import { playerStore } from "../../../../store/player.store"
import * as THREE from "three"
import { useFrame, useThree } from "@react-three/fiber"
import { useEffect, useState } from "react"

const StartWaitZone = ({model}) => {
  const {camera} = useThree()
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000); // Оновлюємо кожну секунду

    return () => clearInterval(intervalId); // Очищаємо інтервал при відмонтовані
  }, []);

  // Обчислюємо кути для стрілок
  const hoursRotation = (Math.PI / 6) * ((currentTime.getHours() % 12) + currentTime.getMinutes() / 60); // 360 градусів / 12 годин
  const minutesRotation = (Math.PI / 30) * currentTime.getMinutes(); //

  const goToPosition = ({ position, rotation }) => {
    playerStore.setPosition({
      currentPosition: position,
      prevPosition: position,
      currentRotation: rotation
    })
  }

  const checkDistance = (objectPosition) => {
    const cameraPosition = new THREE.Vector3();
    camera.getWorldPosition(cameraPosition);
    const objectPositionVec = new THREE.Vector3(...objectPosition); // розпаковуємо масив координат
    const distance = cameraPosition.distanceTo(objectPositionVec);

    return distance <= 3;
  };

  return (
    <>
      <primitive rotation={[-hoursRotation,0,0]} object={model.nodes["clock_line_small"]} />
      <primitive rotation={[-minutesRotation,0,0]} object={model.nodes["clock_line_big"]} />
      <RigidBody type="fixed" colliders="cuboid">
        <group
          onPointerOver={(e) => {
            if (!checkDistance([-11, 1.2, -8.8])) return
            playerStore.setActiveNote("sit")
          }}
          onPointerOut={(e) => playerStore.clearActiveNote()}
          onClick={() => {
            if (!checkDistance([-11, 1.2, -8.8])) return
            goToPosition({
              position: [-11, 1.2, -8.8],
              rotation: [3.14, 0, 3.14]
            })
          }}
        >
          <primitive object={model.nodes["start_sofa1"]} />
        </group>
      </RigidBody>

      <RigidBody type="fixed" colliders="cuboid">
        <group
          onPointerOver={(e) => {
            if (!checkDistance([-13.9, 1.1, -6.6])) return
            playerStore.setActiveNote("sit")
          }}
          onPointerOut={(e) => playerStore.clearActiveNote()}
          onClick={() => {
            if (!checkDistance([-13.9, 1.1, -6.6])) return
            goToPosition({
              position: [-13.9, 1.1, -5.6],
              rotation: [3.14, -Math.PI / 2, 3.14]
            })
          }}
        >
          <primitive object={model.nodes["start_sofa2"]} />
        </group>
      </RigidBody>

      <RigidBody type="fixed" colliders="ball">
        <group
          onPointerOver={(e) => {
            if (!checkDistance([-6, 1.1, -8.6])) return
            playerStore.setActiveNote("sit")
          }}
          onPointerOut={(e) => playerStore.clearActiveNote()}
          onClick={() => {
            if (!checkDistance([-6, 1.1, -8.6])) return
            goToPosition({
              position: [-6, 1.1, -8.6],
              rotation: [3.14, -Math.PI / 2 + 0.3, 3.14]
            })
          }}
        >
          <primitive object={model.nodes["start_chair1"]} />
        </group>
      </RigidBody>
      <RigidBody type="fixed" colliders="ball">
        <group
          onPointerOver={(e) => {
            if (!checkDistance([-1.2, 1.1, -8.6])) return
            playerStore.setActiveNote("sit")
          }}
          onPointerOut={(e) => playerStore.clearActiveNote()}
          onClick={() => {
            if (!checkDistance([-1.2, 1.1, -8.6])) return
            goToPosition({
              position: [-1.2, 1.1, -8.6],
              rotation: [3.14, -Math.PI / 2 + 0.3, 3.14]
            })
          }}
        >
          <primitive object={model.nodes["start_chair2"]} />
        </group>
      </RigidBody>
      <RigidBody type="fixed" colliders="ball">
        <group
          onPointerOver={(e) => {
            if (!checkDistance([-3.7, 1.1, -8.6])) return
            playerStore.setActiveNote("sit")
          }}
          onPointerOut={(e) => playerStore.clearActiveNote()}
          onClick={() => {
            if (!checkDistance([-3.7, 1.1, -8.6])) return
            goToPosition({
              position: [-3.7, 1.1, -8.6],
              rotation: [3.14, Math.PI / 2 - 0.3, 3.14]
            })
          }}
        >
          <primitive object={model.nodes["start_chair3"]} />
        </group>
      </RigidBody>
      <RigidBody type="fixed" colliders="ball">
        <group
          onPointerOver={(e) => {
            if (!checkDistance([1, 1.1, -8.6])) return
            playerStore.setActiveNote("sit")
          }}
          onPointerOut={(e) => playerStore.clearActiveNote()}
          onClick={() => {
            if (!checkDistance([1, 1.1, -8.6])) return
            goToPosition({
                position: [1, 1.1, -8.6],
                rotation: [3.14, Math.PI / 2 - 0.3, 3.14]
              }
            )
          }}
        >
          <primitive object={model.nodes["start_chair4"]} />
        </group>
      </RigidBody>

      <RigidBody type="fixed" colliders="cuboid">
        <primitive object={model.nodes["start_table1"]} />
      </RigidBody>
      <RigidBody type="fixed" colliders="cuboid">
        <primitive object={model.nodes["start_table2"]} />
      </RigidBody>
    </>
  )
}

export {
  StartWaitZone
}